import { render, staticRenderFns } from "./MobileStoreButtons.vue?vue&type=template&id=51d8c254&scoped=true"
import script from "./MobileStoreButtons.vue?vue&type=script&lang=js"
export * from "./MobileStoreButtons.vue?vue&type=script&lang=js"
import style0 from "./MobileStoreButtons.vue?vue&type=style&index=0&id=51d8c254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d8c254",
  null
  
)

export default component.exports